import { Fragment, useContext } from "react";
import { IoSendSharp } from "react-icons/io5";
import { PermissionLink, TableNumber } from "components";
import { AgedType } from "../types";
import moment from "moment";
import { convertNumber } from "utils";
import { dataContextAged } from "..";
import { PERMISION } from "security";

export function Item(props: {
    data: AgedType
    index: number,
}) {
     const { currentPage, limit, size, total } = useContext(dataContextAged)
    // Vars
    const balance = convertNumber(props.data.balance).intoCurrency
    const total_amount = convertNumber(props.data.total_amount).intoCurrency

    return (
        <Fragment>
            <tr >
               <td>{TableNumber({ dataLength: size, pageCurrent: currentPage, index: props.index, limit: limit, totalData: total })}</td>
                <td>
                    <PermissionLink permission={PERMISION.SALES.REGISTER.AGED_RECEIVABLE.UPDATE} target="_blank" rel="noopener noreferrer" to={`/sales/transaction/invoice/edit/${props.data.invoice_id}`} >
                        <IoSendSharp />
                    </PermissionLink>
                </td>
                <td>{props.data.trx_code}</td>
                <td>{props.data.trx_code_so}</td>
                <td>{moment(props.data.transaction_date).format("DD/MM/YYYY")}</td> 
                <td>{props.data.customer.customer_name}</td>
                <td className="text-right">{total_amount}</td>
                <td className="text-right">{props.data.aged_receivable <= 7 ? balance : ''}</td>
                <td className="text-right">{props.data.aged_receivable > 7 && props.data.aged_receivable <= 15 ? balance : ''}</td>
                <td className="text-right">{props.data.aged_receivable > 15 && props.data.aged_receivable <= 21 ? balance : ''}</td>
                <td className="text-right">{props.data.aged_receivable > 21 && props.data.aged_receivable <= 30 ? balance : ''}</td>
                <td className="text-right">{props.data.aged_receivable > 30 ? balance : ''}</td>
            </tr>
        </Fragment>
    )
}